import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = [
    "blockEditor", "preFillEditor",
    "blockText", "preFillText",
    "blockDate", "preFillDate",
    "aiPromptInput", "generateButton", "richTextPdfInput"
  ];

  connect() {
    if(this.hasBlockEditorTarget && this.hasPreFillEditorTarget) 
    {
      this.blockEditorTarget.addEventListener("trix-change", () => {
        this.preFillEditorTarget.inputElement.value = this.blockEditorTarget.inputElement.value;
      })
    }
    else if(this.hasBlockTextTarget && this.hasPreFillTextTarget) 
    {
      this.blockTextTarget.addEventListener("keyup", () => {
        this.preFillTextTarget.value = this.blockTextTarget.value;
      })
    }
    else if(this.hasBlockDateTarget && this.hasPreFillDateTarget) 
    {
      this.blockDateTarget.addEventListener("change", () => {
        this.preFillDateTarget.value = this.blockDateTarget.value;
      });
    }
  }

  generateAIText(event) {
    event.preventDefault();

    let aiPromptValue;
    const blockId = this.element.dataset.blockId;
    const taskId = this.element.dataset.taskId
    const projectId = this.element.dataset.projectId


    var task_spinner = document.querySelector(`.task-ai-process-spinner-${taskId}`)
    var ai_loading_indicator = document.querySelector(`.ai-loading-indicator-${blockId}`)
    var content = document.querySelector(`.ai-content-${blockId}`)
    var project_ai_loading_indicator = document.querySelector(`.project-ai-loading-indicator-${projectId}`)

    if (ai_loading_indicator) ai_loading_indicator.style.display = ""
    if (task_spinner) task_spinner.style.display = ""
    if (project_ai_loading_indicator) project_ai_loading_indicator.style.display = ""
    if (content) content.innerHTML = ""

    if (this.hasAiPromptInputTarget) {
      aiPromptValue = this.aiPromptInputTarget.value;
    } else {
      const aiPromptElement = document.getElementById(`ai-prompt-${blockId}`);

      if (aiPromptElement) {
        aiPromptValue = aiPromptElement.textContent.trim();
      } else {
        console.error(`AI Prompt element with ID ai-prompt-${blockId} not found.`);
        // this.showError("AI Prompt element not found. Please check the block ID.");
        return;
      }
    }

    if (!aiPromptValue) {
      // this.showError("AI Prompt value is empty. Please provide a valid prompt.");
      return;
    }

    // Disable button and show loading state
    this.setButtonLoading(true);

    // Get the URL from the button's data attribute
    const url = this.generateButtonTarget.dataset.url;

    // Create a FormData object and append the prompt value
    const formData = new FormData();
    formData.append('ai_prompt', aiPromptValue);

    // Send the PUT request using fetch
    fetch(url, {
      method: "PUT",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        "Accept": "application/json"
      },
      body: formData
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then(data => {
            throw new Error(data.error || "Network response was not ok");
          });
        }
        return response.json();
      })
      .then((data) => {
        if (data.success) {
          console.log("AI Text generation started:", data.message);
          // this.showSuccess("AI text generation started...");
          // Update credit balance if provided
          if (data.available_credits !== undefined) {
            this.updateCreditBalance(data.available_credits);
          }
        } else {
          // this.showError(data.error || "Failed to start AI text generation");
          // Update credit balance if provided
          if (data.available_credits !== undefined) {
            this.updateCreditBalance(data.available_credits);
          }
        }
      })
      .catch((error) => {
        console.error("Error generating AI Text:", error);
        // this.showError(error.message || "An error occurred while generating AI text");
      })
      .finally(() => {
        this.setButtonLoading(false);
      });
  }

  setButtonLoading(loading) {
    const button = this.generateButtonTarget;
    const originalText = button.dataset.text;
    
    if (loading) {
      button.disabled = true;
      button.innerHTML = `${originalText}`;
    } else {
      button.disabled = false;
      button.innerHTML = originalText;
    }
  }

  showError(message) {
    // Show error message in a user-friendly way
    const errorDiv = document.createElement('div');
    errorDiv.className = 'alert alert-danger';
    errorDiv.style.cssText = 'position: fixed; top: 20px; right: 20px; z-index: 9999; max-width: 400px;';
    errorDiv.innerHTML = `
      <div style="display: flex; align-items: center; gap: 10px;">
        <span style="color: #dc3545;">⚠️</span>
        <span>${message}</span>
        <button onclick="this.parentElement.parentElement.remove()" style="background: none; border: none; color: #dc3545; font-size: 18px; cursor: pointer;">&times;</button>
      </div>
    `;
    
    document.body.appendChild(errorDiv);
    
    // Auto-remove after 5 seconds
    setTimeout(() => {
      if (errorDiv.parentElement) {
        errorDiv.remove();
      }
    }, 5000);
  }

  showSuccess(message) {
    // Show success message
    const successDiv = document.createElement('div');
    successDiv.className = 'alert alert-success';
    successDiv.style.cssText = 'position: fixed; top: 20px; right: 20px; z-index: 9999; max-width: 400px;';
    successDiv.innerHTML = `
      <div style="display: flex; align-items: center; gap: 10px;">
        <span style="color: #28a745;">✅</span>
        <span>${message}</span>
        <button onclick="this.parentElement.parentElement.remove()" style="background: none; border: none; color: #28a745; font-size: 18px; cursor: pointer;">&times;</button>
      </div>
    `;
    
    document.body.appendChild(successDiv);
    
    // Auto-remove after 3 seconds
    setTimeout(() => {
      if (successDiv.parentElement) {
        successDiv.remove();
      }
    }, 3000);
  }

  updateCreditBalance(availableCredits) {
    // Update credit balance display in real-time
    const creditBalanceElements = document.querySelectorAll('[data-credit-balance]');
    creditBalanceElements.forEach(element => {
      element.textContent = `${availableCredits} credits`;
    });
    
    // Update credit balance in credit display components
    const creditDisplayElements = document.querySelectorAll('.credit-balance-amount');
    creditDisplayElements.forEach(element => {
      element.textContent = `${availableCredits} credits`;
    });
  }

  generatePDF(event) {
    event.preventDefault();

    const url = this.generateButtonTarget.dataset.url;
    const globalStatusDiv = document.getElementById("global-task-generation-status");

    if (!url) {
      console.error("No URL found for PDF generation.");
      return;
    }

    this.updateStatus(globalStatusDiv, "PDF is generating, please wait...");

    fetch(url, {
      method: "PUT",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
      }
    })
      .catch((error) => {
        console.error("Error generating PDF:", error);
        this.updateStatus(globalStatusDiv, "Failed to generate PDF. Please try again.", 4000, true);
      });
  }

  updateStatus(element, message, timeout = 2000, isError = false) {
    if (!element) return;

    element.textContent = message;

    if (isError) {
      element.classList.add("block", "failed");
    } else {
      element.classList.add("block");
    }

    setTimeout(() => {
      element.classList.remove("block");
    }, timeout);
  }
}
